import React from "react";
import { FormattedMessage } from "react-intl";

import { EmptyArea } from "@sincro/react-empty-area";

import { ApplicationCard } from "./ApplicationCard";

export class ApplicationCards extends React.Component {
  render() {
    function NoAppsFound() {
      return (
        <EmptyArea className="dcc-empty-area">
          <FormattedMessage
            id="Dcc.noApps"
            defaultMessage="Your user does not have access to any applications"
          />
        </EmptyArea>
      );
    }
    const { apps, isAuthenticated } = this.props;
    return (
      <>
        {isAuthenticated ? (
          apps.length > 0 && <ApplicationCard apps={apps} />
        ) : (
          <NoAppsFound />
        )}
      </>
    );
  }
}
